import { Root, View, Divider } from '@piwikpro/ui-components';
import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import type { RootState } from './store';
import { useAppSelector } from './hooks';
import PiwikPro from '@piwikpro/react-piwik-pro';

import {
  Footer,
  Logo,
  OngoingIncidentInfo,
  MaintenanceInfo,
  PastIncidentsList,
  UptimeGraphList,
} from './components';
import { FetchIncidents, selectIsLoading, getConfig } from './incidentSlice';
import { store } from './store';
import { i18n } from './translations/i18n';

const App: React.FC = () => {
  const isLoading = useAppSelector(selectIsLoading);

  const infraName = useAppSelector(
    (state: RootState) => state.incidents.infraName
  );

  useEffect(() => {
    const fetchConfig = async () => {
      const data = await getConfig();
      if (data.tracker_id_site && data.tracker_url) {
        PiwikPro.initialize(data.tracker_id_site, data.tracker_url);
      }
    };

    fetchConfig();
  }, []);

  useEffect(() => {
    FetchIncidents(store);
    setInterval(() => FetchIncidents(store), 1000 * 60 * 5);
  }, []);

  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Root title="Status page">
          <Root.TopSection>
            <Logo />
          </Root.TopSection>
          {isLoading ? (
            <View>
              <View.Body>
                <p className="loading">Loading incidents, please wait...</p>
              </View.Body>
            </View>
          ) : (
            <View>
              <View.Header
                title={<span className="infraName">{infraName}</span>}
              ></View.Header>
              <View.Body>
                <Divider />
                <OngoingIncidentInfo />
                <MaintenanceInfo />
                <Divider />
                <UptimeGraphList />
                <PastIncidentsList />
              </View.Body>
            </View>
          )}
          <Root.BottomSection>
            <Footer></Footer>
          </Root.BottomSection>
        </Root>
      </I18nextProvider>
    </BrowserRouter>
  );
};

export default App;
